import React from 'react'
import Loderimg from '../../assets/images/loader.svg';

const Loader = () => {
  return (
    <div className='global-loader'>
      <img src={Loderimg} alt='Loder' title='Loder' />
    </div>
  )
}

export default Loader